<template>
    <custom-drawer
        v-loading="m__loading"
        size="50%"
        :wrapper_closable="false"
        :visible.sync="visible_in_line"
    >
        <template slot="title">
            <div class="flex items-center justify-between flex-1 h-full pr-5">
                <div>
                    <p class="font-semibold text-[0.9rem]">
                        {{ $t('page.campaign.adgroup_pane.edit_campaign') }}
                    </p>
                    <p
                        v-if="selected_item"
                        class="text-desc-text text-[0.75rem]"
                    >
                        #{{ selected_item.campaign.campaign_id }}
                    </p>
                </div>
                <el-button
                    icon="el-icon-check"
                    type="primary"
                    size="small"
                    @click="handleEditCampaign()"
                >
                    {{ $t('button.confirm') }}
                </el-button>
            </div>
        </template>

        <div class="px-5 py-8">
            <div class="component-box">
                <p class="font-semibold text-[0.9rem]">
                    {{ $t('common.objective_type') }}
                </p>

                <p class="text-desc-text text-[0.85rem] mt-1">
                    {{ title }}
                </p>

                <div
                    v-if="selected_ads_objective"
                    class="mt-4 w-[320px] rounded-lg py-6 px-8 flex space-x-4 cursor-pointer border-[1px] box-border select-none border-brand-atosa bg-white"
                >
                    <div class="min-w-10">
                        <font-awesome-icon
                            size="lg"
                            :icon="selected_ads_objective.icon"
                        />
                    </div>

                    <div>
                        <p class="font-semibold text-[0.95rem] mb-1">
                            {{ selected_ads_objective.title }}
                        </p>

                        <p class="component-text-desc min-h-[44px]">
                            {{ selected_ads_objective.description }}
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="selected_item" class="component-box mt-4">
                <div>
                    <label class="component-label">
                        {{ $t('page.campaign.campaign_name') }}
                    </label>
                    <br />
                    <el-input
                        ref="el_input_campaign_name"
                        v-model="selected_item.campaign.campaign_name"
                        size="small"
                        class="w-1/2"
                    ></el-input>
                </div>
                <div class="mt-4">
                    <el-checkbox
                        v-model="checked_no_limit"
                        :disabled="
                            selected_item.campaign.budget_mode !==
                            'BUDGET_MODE_INFINITE'
                        "
                        @change="handleChangeBudgetMode"
                    >
                        No limit
                    </el-checkbox>

                    <div
                        v-if="!checked_no_limit"
                        class="flex w-1/2 mt-2 space-x-2"
                    >
                        <el-select
                            v-model="selected_item.campaign.budget_mode"
                            disabled
                            size="small"
                            filterable
                            :placeholder="$t('input.placeholder.please_select')"
                        >
                            <el-option
                                v-for="item in p__budget_mode_options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <el-input
                            v-model="selected_item.campaign.budget"
                            class="flex-1"
                            size="small"
                            type="number"
                            :placeholder="$t('input.placeholder.please_input')"
                        >
                            <template slot="append">
                                {{ currency }}
                            </template>
                        </el-input>
                    </div>
                </div>
            </div>
        </div>
    </custom-drawer>
</template>

<script>
import { updateCampaign } from '@/services/atosa-tiktok-ads/campaign'

export default {
    props: [
        'visible',
        'selected_item',
        'currency',
        'tiktok_account_id',
        'advertiser_id',
        'min_budget_campaign',
        'belong_to_atosa'
    ],

    data() {
        return {
            checked_no_limit: true,
            selected_ads_objective: null,
            title: ''
        }
    },

    computed: {
        visible_in_line: {
            get: function () {
                return this.visible
            },
            set: function (val) {
                this.$emit('update:visible', val)
            }
        }
    },

    watch: {
        selected_item() {
            this.getStateInfor()
        }
    },

    mounted() {
        this.getStateInfor()
    },

    methods: {
        getStateInfor() {
            if (!this.selected_item) {
                return
            }
            const item = this.p__list_ads_objectives.find((i) =>
                i.items.some(
                    (item) =>
                        item.value ===
                        this.selected_item.campaign.objective_type
                )
            )

            if (item) {
                this.title = item.title

                const temp = item.items.find(
                    (i) =>
                        (i.value ===
                            this.selected_item.campaign.budget_mode) ===
                        ''
                )

                if (temp) {
                    this.selected_ads_objective = temp
                }
            }

            this.checked_no_limit =
                this.selected_item.campaign.budget_mode ===
                'BUDGET_MODE_INFINITE'
        },

        async handleChangeBudgetMode() {
            this.selected_item.campaign.budget_mode = this.checked_no_limit
                ? 'BUDGET_MODE_INFINITE'
                : 'BUDGET_MODE_TOTAL'

            if (!this.checked_no_limit) {
                this.selected_item.campaign.budget = this.min_budget_campaign
            }
        },

        async handleEditCampaign() {
            if (
                this.selected_item.campaign.budget_mode ===
                    'BUDGET_MODE_TOTAL' &&
                this.selected_item.campaign.budget < this.min_budget_campaign
            ) {
                this.p__showNotify(
                    'warning',
                    this.$t('page.campaign.please_budget_than_min', {
                        currency: this.currency,
                        budget: this.min_budget_campaign
                    })
                )

                return
            }

            try {
                await updateCampaign(this.tiktok_account_id, {
                    advertiser_id: this.advertiser_id,
                    campaign_name: this.selected_item.campaign.campaign_name,
                    campaign_id: this.selected_item.campaign.campaign_id,
                    budget_mode: this.selected_item.campaign.budget_mode,
                    budget: this.selected_item.campaign.budget,
                    belong_to_atosa: this.belong_to_atosa
                })

                this.p__event_bus.$emit('eb_reload_campaign')

                this.p__showNotify(
                    'success',
                    this.$t('common.update_data_success')
                )

                this.visible_in_line = false
            } catch (error) {
                console.error(error)
            }
        }
    }
}
</script>
